import apiService from './apiService';

const galleryService = {
  /**
   * Képek lekérdezése egy szolgáltató galériájából (isProfileImage: false).
   * @param {number} providerId - A szolgáltató ID-ja.
   * @returns {Promise<object>} A galéria képek listája.
   */
  getGalleryImages: async (providerId) => {
    try {
      const response = await apiService.get(`/providers/${providerId}/gallery`);
      return response;
    } catch (error) {
      console.error(`Error fetching gallery images for provider ${providerId}:`, error);
      throw error;
    }
  },

  /**
   * Profilkép lekérdezése egy szolgáltatóhoz (isProfileImage: true).
   * @param {number} providerId - A szolgáltató ID-ja.
   * @returns {Promise<object>} A profilkép objektum.
   */
  getProfileImage: async (providerId) => {
    try {
      const response = await apiService.get(`/providers/${providerId}/profile-image`);
      return response;
    } catch (error) {
      console.error(`Error fetching profile image for provider ${providerId}:`, error);
      throw error;
    }
  },

  /**
   * Szolgáltató galéria képeinek frissítése (metaadatok, sorrend, featured).
   * @param {number} providerId - A szolgáltató ID-ja.
   * @param {Array<object>} images - A galéria képek listája.
   * @returns {Promise<object>} A backend válasza.
   */
  updateGallery: async (providerId, images) => {
    try {
      const response = await apiService.put(`/providers/${providerId}/gallery`, { images });
      return response;
    } catch (error) {
      console.error(`Error updating gallery for provider ${providerId}:`, error);
      throw error;
    }
  },

  /**
   * Szolgáltató profilképének beállítása/frissítése.
   * @param {number} providerId - A szolgáltató ID-ja.
   * @param {string | null} imageUrl - Az új profilkép URL-je, vagy null a törléshez.
   * @returns {Promise<object>} A backend válasza.
   */
  updateProfileImage: async (providerId, imageUrl) => {
    try {
      const response = await apiService.put(`/providers/${providerId}/profile-image`, { imageUrl });
      return response;
    } catch (error) {
      console.error(`Error updating profile image for provider ${providerId}:`, error);
      throw error;
    }
  },

  /**
   * Kép törlése a galériából (és R2-ről).
   * @param {number} providerId - A szolgáltató ID-ja.
   * @param {number} imageId - A törlendő kép ID-ja.
   * @returns {Promise<object>} A backend válasza.
   */
  deleteGalleryImage: async (providerId, imageId) => {
    try {
      const response = await apiService.delete(`/providers/${providerId}/gallery/${imageId}`);
      return response;
    } catch (error) {
      console.error(`Error deleting image ${imageId} from provider ${providerId}:`, error);
      throw error;
    }
  },
};

export default galleryService;